export const simBillingCsvFilter = (role, tile, content) => {
  let csv = content;
  ({
    ZD: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Sell: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer Id"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Role Type"] = obj["partnerRoletype"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["description"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    ARD: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ARD"] = obj["retailer"] ?? "";
              obj["ARD Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ARD"] = obj["rds"] ?? "";
              obj["ARD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ARD"] = obj["rds"] ?? "";
              obj["ARD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    ZDMT: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZDMT"] = obj["zd"] ?? "";
              obj["ZDMT Name"] = obj["zdName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZDMT"] = obj["zd"] ?? "";
              obj["ZDMT Name"] = obj["zdName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        }
      }[tile]?.());
      return csv;
    },
    RDS: () => {
      ({
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Role Type"] = obj["partnerRoletype"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["partnerRoletype"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["description"];
              delete obj["jprTypeName"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Role Type"] = obj["partnerRoletype"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["partnerRoletype"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["description"];
              delete obj["jprTypeName"];
              return obj;
            });
          return csv;
        },
        Sell: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Role Type"] = obj["partnerRoletype"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["description"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    MARD: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["MARD"] = obj["retailer"] ?? "";
              obj["MARD Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["MARD"] = obj["rds"] ?? "";
              obj["MARD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              obj["Role Type"] = obj["partnerRoletype"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["MARD"] = obj["rds"] ?? "";
              obj["MARD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              obj["Role Type"] = obj["partnerRoletype"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    END: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ED ZD"] = obj["retailer"] ?? "";
              obj["ED ZD Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    RZD: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["Partner Id"] = obj["retailer"] ?? "";
              obj["Partner Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RZD"] = obj["rds"] ?? "";
              obj["RZD Name"] = obj["rdsName"] ?? "";
              obj["DRS Code"] = obj["retailer"] ?? "";
              obj["DRS Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Sell: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RZD"] = obj["rds"] ?? "";
              obj["RZD Name"] = obj["rdsName"] ?? "";
              obj["DRS Code"] = obj["retailer"] ?? "";
              obj["DRS Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    ITZ: () => {
      ({
        Primary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["retailer"] ?? "";
              obj["IT ZD Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["retailer"] ?? "";
              obj["ITD Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer Id"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Sell: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer Id"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    ITD: () => {
      ({
        Secondary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["retailer"] ?? "";
              obj["ITD Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Tertiary: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer Id"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
        Sell: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC Code"] = obj["jioCenter"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ITZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer Id"] = obj["retailer"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["MTD Count"] = obj["mtd_qty"] ?? "";
              obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jioCenter"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["mtd_qty"];
              delete obj["lmtd_qty"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["description"];
              delete obj["jprTypeName"];
              delete obj["partnerRoletype"];
              return obj;
            });
          return csv;
        },
      }[tile]?.());
      return csv;
    },
    JPT: () => {
      ({
        Tertiary: () => {
          csv = content && content.map(obj => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj['JC ID']=obj['jioCenter'] ?? "";
            obj['JC Name']=obj['jcName'] ?? "";
            obj['JIO Point Id']=obj['jio_point_id'] ?? "";
            obj['JIO Point Name']=obj['jio_point_name'] ?? ""
            obj['Retailer Id']=obj['retailer'] ?? ""
            obj['Retailer Name']=obj['retailerName'] ?? ""
            obj['Partner Role Name']=obj['partner_role_name'] ?? ""
            obj['Partner Role Type']=obj['partnerRoletype'] ?? ""
            obj['JPR Type Name']=obj['jprTypeName'] ?? ""
            obj['MTD Count']=obj['mtd_qty'] ?? ""
            obj['LMTD Count']=obj['lmtd_qty'] ?? ""
            delete obj["region"]
            delete obj["state"]
            delete obj['jioCenter']
            delete obj['jcName']
            delete obj['jio_point_id']
            delete obj['jio_point_name']
            delete obj['retailer']
            delete obj['retailerName']
            delete obj['partner_role_name'] 
            delete obj['partnerRoletype']
            delete obj['jprTypeName']
            delete obj['mtd_qty']
            delete obj['lmtd_qty']
            return obj;
          })
          return csv;
        },
        Sell: () => {
          csv = content && content.map(obj => {
            obj["Region"] = obj["region"] ?? "";
            obj["State"] = obj["state"] ?? "";
            obj['JC ID']=obj['jioCenter'] ?? "";
            obj['JC Name']=obj['jcName'] ?? "";
            obj['JIO Point Id']=obj['jio_point_id'] ?? "";
            obj['JIO Point Name']=obj['jio_point_name'] ?? ""
            obj['Retailer Id']=obj['retailer'] ?? ""
            obj['Retailer Name']=obj['retailerName'] ?? ""
            obj['Partner Role Name']=obj['partner_role_name'] ?? ""
            obj['Partner Role Type']=obj['partnerRoletype'] ?? ""
            obj['JPR Type Name']=obj['jprTypeName'] ?? ""
            obj['MTD Count']=obj['mtd_qty'] ?? ""
            obj['LMTD Count']=obj['lmtd_qty'] ?? ""
            delete obj["region"]
            delete obj["state"]
            delete obj['jioCenter']
            delete obj['jcName']
            delete obj['jio_point_id']
            delete obj['jio_point_name']
            delete obj['retailer']
            delete obj['retailerName']
            delete obj['partner_role_name'] 
            delete obj['partnerRoletype']
            delete obj['jprTypeName']
            delete obj['mtd_qty']
            delete obj['lmtd_qty']
            return obj;
          })
          return csv;
        }
      }[tile]?.());
      return csv;
    },
    JP:()=>{
      const mapJpSimBillingRow = (obj) => {
        obj["Region"] = obj["region"] ?? "";
        obj["State"] = obj["state"] ?? "";
        obj["JC ID"] = obj["jioCenter"] ?? "";
        obj["JC Name"] = obj["jcName"] ?? "";
        obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
        obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
        obj["Retailer Id"] = obj["retailer"] ?? "";
        obj["Retailer Name"] = obj["retailerName"] ?? "";
        obj["Partner Role Name"] = obj["partner_role_name"] ?? "";
        obj["Partner Role Type"] = obj["partnerRoletype"] ?? "";
        obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
        obj["MTD Count"] = obj["mtd_qty"] ?? "";
        obj["LMTD Count"] = obj["lmtd_qty"] ?? "";
        delete obj["region"];
        delete obj["state"];
        delete obj["jioCenter"];
        delete obj["jcName"];
        delete obj["jio_point_id"];
        delete obj["jio_point_name"];
        delete obj["retailer"];
        delete obj["retailerName"];
        delete obj["partner_role_name"];
        delete obj["partnerRoletype"];
        delete obj["jprTypeName"];
        delete obj["mtd_qty"];
        delete obj["lmtd_qty"];
        return obj;
      };
      // Backend sellthrough CSV for JP/JC returns SimbillingJP rows (tertiary excel shape).
      // Missing Tertiary here caused silent download failure after a successful API response.
      const jpTileHandlers = {
        Secondary: () => {
          csv = content && content.map(mapJpSimBillingRow);
          return csv;
        },
        Tertiary: () => {
          csv = content && content.map(mapJpSimBillingRow);
          return csv;
        },
        Sell: () => {
          csv = content && content.map(mapJpSimBillingRow);
          return csv;
        },
      };
      const tileHandler = jpTileHandlers[tile];
      if (typeof tileHandler === "function") {
        tileHandler();
      }
      return csv;
    }
  }[role]?.());
  return csv;
};